import React, { Component } from 'react';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import CreateButton from 'components/button/CreateButton';
import compose from 'recompose/compose';
import DiscountCodesList from './DiscountCodesList';
import ExportButton from 'components/button/actions/ExportButton';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import PropTypes from 'prop-types';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { exportDiscountCodes } from 'store/actions/discountCodes/exportDiscountCodes';
import { updateFilters } from 'store/actions/listActions';

class DiscountCodesListContainer extends Component {
    constructor() {
        super();

        this.handleExport = this.handleExport.bind(this);
    }

    componentDidMount() {
        const {
            discountId,
            updateDiscountCodesFilters,
        } = this.props;

        updateDiscountCodesFilters({
            filter: {
                discount_id: {
                    matchType: filterMatchTypes.matchOneOf,
                    value: [
                        discountId,
                    ],
                },
            },
        });
    }

    componentWillUnmount() {
        const {
            updateDiscountCodesFilters,
        } = this.props;

        updateDiscountCodesFilters({
            filter: {},
        });
    }

    handleExport() {
        const {
            discountId,
            exportDiscountCodes,
        } = this.props;

        exportDiscountCodes({
            filters: {
                discount_id: [
                    discountId,
                ],
            },
        });
    }

    render() {
        const {
            discountId,
            resource,
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.discounts.title'),
                link: '/discounts',
            },
            {
                label: translate('resources.discount_codes.title'),
            },
        ];

        const initialFilters = {
            is_enabled: {
                matchType: filterMatchTypes.equals,
                value: '1',
            },
            status: {
                matchType: filterMatchTypes.equals,
                value: 'unused',
            },
        };

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.discount_codes.title') } />

                    <Actions>
                        <ExportButton onClick={ this.handleExport } />

                        <CreateButton basePath={ `discounts/${ discountId }/${ resource }` } />
                    </Actions>
                </Header>

                <DiscountCodesList
                    { ...this.props }
                    initialFilters={ initialFilters }
                />
            </div>
        );
    }
}

DiscountCodesListContainer.propTypes = {
    discountId: PropTypes.number.isRequired,
    exportDiscountCodes: PropTypes.func,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    updateDiscountCodesFilters: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, props) => {
    const {
        actionType,
    } = props;

    return {
        exportDiscountCodes: exportDiscountCodes,
        updateDiscountCodesFilters: (payload) => {
            dispatch(updateFilters(actionType, payload));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(DiscountCodesListContainer);



// WEBPACK FOOTER //
// ./src/pages/discountCodes/list/DiscountCodesListContainer.js